import {cashBoxHeaderFilter} from "../../../hoc/cashBoxHeaderFilter";
import CashBoxCashInRegister from "./CashBoxCashInRegister";

const CashBoxCashInDataTableHeader = cashBoxHeaderFilter(CashBoxCashInRegister, "CashBoxCashInDataTableHeader",)

export default CashBoxCashInDataTableHeader
